"use strict";

require("core-js/modules/es6.object.define-property");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var components_1 = require("@lsg/components");

exports.CustomTeaserCTA = function (_a) {
  var ctaLabel = _a.ctaLabel,
      ctaTarget = _a.ctaTarget,
      ctaStyle = _a.ctaStyle,
      showOverlay = _a.showOverlay;

  var _b;

  return react_1["default"].createElement(react_1["default"].Fragment, null, !ctaStyle ? react_1["default"].createElement(components_1.IconLink, {
    iconName: components_1.Icon.Names.interaction_arrows_chevronRight,
    look: (_b = components_1.IconLink.Looks) === null || _b === void 0 ? void 0 : _b.RIGHT,
    href: ctaTarget,
    target: '_blank',
    htmlAttrs: {
      rel: 'noopener'
    },
    onClick: function onClick() {
      return showOverlay && showOverlay(true);
    }
  }, ctaLabel) : react_1["default"].createElement(components_1.Button, {
    href: ctaTarget,
    target: '_blank',
    htmlAttrs: {
      rel: 'noopener'
    },
    onClick: function onClick() {
      return showOverlay && showOverlay(true);
    }
  }, ctaLabel));
};